import { useSearchParams } from 'react-router-dom';
import { FilterState } from '@/fsd/shared/ui/filter-panel/types';

export const useInitialFilters = (paramMap: Record<string, 'boolean' | 'string' | 'number'>): FilterState => {
  const [searchParams] = useSearchParams();
  const initialFilters: FilterState = {};

  Object.entries(paramMap).forEach(([key, type]) => {
    const value = searchParams.get(key);
    if (value !== null) {
      if (type === 'boolean') {
        initialFilters[key] = [value === 'true'];
      } else if (type === 'number') {
        initialFilters[key] = [Number(value)];
      } else {
        initialFilters[key] = [value];
      }
    }
  });

  return initialFilters;
};
